// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-flat-pickr input{padding-left:32px}.app-flat-pickr .dayContainer{padding:20px}", "",{"version":3,"sources":["webpack://src/components/shared/AppFlatPickr.vue"],"names":[],"mappings":"AAAA,sBAAsB,iBAAiB,CAAC,8BAA8B,YAAY","sourcesContent":[".app-flat-pickr input{padding-left:32px}.app-flat-pickr .dayContainer{padding:20px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
